<div *ngIf="loading$ | async" class="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75">
  <div class="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
</div>
